"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _Tiles = _interopRequireDefault(require("../../components/Tiles"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _ClassesDivisions = _interopRequireDefault(require("../ClassesDivisions"));
var _AccountHistory = _interopRequireDefault(require("../AccountHistory"));
var _Container = _interopRequireDefault(require("../PlanDesign/Container"));
var _Commissions = _interopRequireDefault(require("../Commissions"));
var _MasterApplication = _interopRequireDefault(require("../MasterApplication"));
var _Pricing = _interopRequireDefault(require("../Pricing"));
var _AssignPlans = _interopRequireDefault(require("../AssignPlans"));
var _MetaBlock = _interopRequireDefault(require("../../components/MetaBlock"));
var _MetaModal = _interopRequireDefault(require("../../components/Modals/MetaModal"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-empty-function */
var Quote = /*#__PURE__*/function (_PureComponent) {
  function Quote() {
    var _this;
    (0, _classCallCheck2["default"])(this, Quote);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Quote, [].concat(args)), _this.state = {
      showAccountSettingsModal: false,
      showGoLiveDialog: false,
      showCompleteRevisionDialog: false,
      showSendForReviewDialog: false,
      showConvertQuote: false,
      showQuoteMetaModal: false
    }, _this._getTiles = function () {
      var tiles = [{
        title: _i18n["default"].t(_tokens["default"].titles.classesAndDivisions),
        description: _i18n["default"].t(_tokens["default"].labels.advisor.manageClassesAndDivisions),
        step: 1,
        onClick: function onClick() {
          return _this.props.setSelectedSection('classes-divisions');
        },
        testid: 'classes-divisions-tile',
        completed: Number(_this.props.quote.meta.state) >= 4
      }, {
        title: _i18n["default"].t(_tokens["default"].titles.accountHistory),
        description: _i18n["default"].t(_tokens["default"].labels.advisor.provideDocuments),
        step: 2,
        onClick: function onClick() {
          return _this.props.setSelectedSection('account-history');
        },
        testid: 'account-history-tile',
        completed: Number(_this.props.quote.meta.state) >= 4
      }, {
        title: _i18n["default"].t(_tokens["default"].titles.planDesign),
        description: _i18n["default"].t(_tokens["default"].labels.advisor.viewCustomizePlanDesigns),
        step: 3,
        onClick: function onClick() {
          return _this.props.setSelectedSection('plan-design');
        },
        testid: 'plan-design-tile',
        completed: Number(_this.props.quote.meta.state) >= 4
      }, {
        title: _i18n["default"].t(_tokens["default"].titles.commissions),
        description: _i18n["default"].t(_tokens["default"].labels.advisor.viewSetCommissionsForAccount),
        step: 4,
        tooltip: {
          tip: _i18n["default"].t(_tokens["default"].labels.advisor.completeSubmitPlanDesigns),
          position: 'right'
        },
        disabled: Number(_this.props.quote.meta.state) < 1,
        onClick: function onClick() {
          return _this.props.setSelectedSection('commissions');
        },
        testid: 'commissions-tile',
        completed: Number(_this.props.quote.meta.state) >= 4
      }, {
        title: _i18n["default"].t(_tokens["default"].titles.masterApplication),
        description: _i18n["default"].t(_tokens["default"].labels.advisor.completeSubmitMasterApplication),
        step: 5,
        tooltip: {
          tip: _i18n["default"].t(_tokens["default"].labels.advisor.completeSubmitCommissions),
          position: 'left'
        },
        disabled: Number(_this.props.quote.meta.state) < 2,
        onClick: function onClick() {
          return _this.props.setSelectedSection('master-application');
        },
        testid: 'master-application-tile',
        completed: Number(_this.props.quote.meta.state) >= 4
      }];
      if (_this.props.isMasterSite) {
        tiles.push({
          title: _i18n["default"].t(_tokens["default"].titles.pricing),
          description: _i18n["default"].t(_tokens["default"].labels.advisor.setPricingForPlanDesigns),
          step: 6,
          tooltip: {
            tip: _i18n["default"].t(_tokens["default"].labels.advisor.pleaseCompleteSubmitMasterApplication),
            position: 'right'
          },
          disabled: Number(_this.props.quote.meta.state) < 3,
          onClick: function onClick() {
            return _this.props.setSelectedSection('pricing');
          },
          testid: 'pricing-tile',
          completed: Number(_this.props.quote.meta.state) > 4
        });
      } else {
        tiles.push({
          title: _i18n["default"].t(_tokens["default"].titles.sendForUnderwriting),
          description: _i18n["default"].t(_tokens["default"].labels.advisor.submitAccountUnderwritingPricing),
          step: 6,
          tooltip: {
            tip: Number(_this.props.quote.meta.state) <= 3 ? _i18n["default"].t(_tokens["default"].labels.advisor.pleaseCompleteSubmitMasterApplication) : _i18n["default"].t(_tokens["default"].labels.advisor.alreadySentQuoteUnderwriting),
            position: 'right',
            alwaysShow: !_this.props.isMasterSite
          },
          disabled: Number(_this.props.quote.meta.state) < 3,
          onClick: _this.props.isMasterSite ? _this._toggleSendForReviewDialog : Number(_this.props.quote.meta.state) <= 3 ? _this._toggleSendForReviewDialog : function () {},
          testid: 'submit-review-tile',
          completed: Number(_this.props.quote.meta.state) >= 4
        });
      }
      tiles.push({
        title: _i18n["default"].t(_tokens["default"].titles.assignPlans),
        description: _i18n["default"].t(_tokens["default"].labels.advisor.assignFinalPlanDesigns),
        step: 7,
        tooltip: {
          tip: Number(_this.props.quote.meta.state) <= 5 ? _i18n["default"].t(_tokens["default"].labels.advisor.assignPlansNote) : _i18n["default"].t(_tokens["default"].labels.advisor.alreadyAssignedPlanDesigns),
          position: 'left',
          alwaysShow: true
        },
        disabled: Number(_this.props.quote.meta.state) < 5,
        onClick: Number(_this.props.quote.meta.state) <= 5 ? function () {
          return _this.props.setSelectedSection('assign-plans');
        } : function () {},
        testid: 'advisor-assign-plans',
        completed: Number(_this.props.quote.meta.state) >= 6
      });
      tiles.push({
        title: _i18n["default"].t(_tokens["default"].titles.requestApproval),
        description: _i18n["default"].t(_tokens["default"].labels.advisor.reviewSendQuote),
        tooltip: {
          tip: Number(_this.props.quote.meta.state) <= 5 ? _i18n["default"].t(_tokens["default"].labels.advisor.completeSubmitAssignPlans) : _i18n["default"].t(_tokens["default"].labels.advisor.alreadySubmittedQuoteApproval),
          position: 'right',
          alwaysShow: !_this.props.isMasterSite && Number(_this.props.quote.meta.state) !== 6
        },
        disabled: Number(_this.props.quote.meta.state) < 6,
        step: 8,
        onClick: _this.props.isMasterSite && Number(_this.props.quote.meta.state) <= 7 || Number(_this.props.quote.meta.state) <= 6 ? function () {
          return _this.props.setSelectedSection('request-approval');
        } : function () {},
        testid: 'finish-setup-tile',
        completed: Number(_this.props.quote.meta.state) >= 7
      });
      return tiles;
    }, _this._toggleMetaModal = function () {
      _this.setState({
        showQuoteMetaModal: !_this.state.showQuoteMetaModal
      });
    }, _this._toggleSendForReviewDialog = function () {
      _this.setState({
        showSendForReviewDialog: !_this.state.showSendForReviewDialog
      });
    }, _this._toggleConvertQuote = function () {
      if (!_this.props.isMasterSite) {
        return null;
      }
      _this.setState({
        showConvertQuote: !_this.state.showConvertQuote
      });
      return true;
    }, _this._convertQuoteToSold = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var success;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.props.isMasterSite) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            _context.next = 4;
            return _this.props.convertQuote();
          case 4:
            success = _context.sent;
            if (success) {
              _this._toggleConvertQuote();
            }
            return _context.abrupt("return", true);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(Quote, _PureComponent);
  return (0, _createClass2["default"])(Quote, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        quote = _this$props.quote,
        whitelabel = _this$props.whitelabel;
      var tiles = this._getTiles();

      // if it's a private label advisor, they must be able to do all steps themselves from the advisor site
      // const isPrivateLabelAdvisor = Boolean(this.props.advisorMeta.privateLabelID);

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.props.selectedSection && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, quote.meta.state >= 2 && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "primary",
        customStyle: {
          display: 'block',
          marginLeft: 'auto',
          height: 45,
          textTransform: "capitalize",
          fontSize: 15
        },
        onClick: this.props.downloadCarrierPackage
      }, _i18n["default"].t(_tokens["default"].buttons.downloadCarrierPackage)), this.props.quote.meta.state === 4 && !this.props.isMasterSite && /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.underwritingQuote),
        subtitle: _i18n["default"].t(_tokens["default"].labels.quotes.underwritingMessage)
      }), this.props.quote.meta.state === 6 && /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].buttons.sendForApproval),
        subtitle: _i18n["default"].t(_tokens["default"].labels.quotes.requestApprovalMessage)
      }), this.props.quote.meta.state === 7 && /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.quotes.signingAuthorityApprovalPending),
        subtitle: _i18n["default"].t(_tokens["default"].labels.quotes.sentToSimplyBenefits)
      }), !this.props.isMasterSite && this.props.quote.meta.state === 8 && /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.quotes.simplyBenefitsApprovalPending),
        subtitle: _i18n["default"].t(_tokens["default"].labels.quotes.finalReviewStage)
      }), this.props.isMasterSite && this.props.currentAccountMeta.state === 8 && this.props.currentAccountMeta.status === 'In Progress' && /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.quotes.quoteSold),
        subtitle: _i18n["default"].t(_tokens["default"].labels.quotes.signingAuthorityAccepted),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.convertQuote),
        btnOnClick: this._toggleConvertQuote
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        margin: "10px"
      }, _i18n["default"].t(_tokens["default"].labels.quotes.quoteSetup)), /*#__PURE__*/_react["default"].createElement(_Tiles["default"], {
        tiles: tiles,
        stepped: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        margin: "20px 10px 15px 10px"
      }, _i18n["default"].t(_tokens["default"].labels.quotes.companyDetails)), /*#__PURE__*/_react["default"].createElement(_MetaBlock["default"], {
        data: quote,
        showModal: this._toggleMetaModal
      }), this.state.showQuoteMetaModal && /*#__PURE__*/_react["default"].createElement(_MetaModal["default"], {
        hideModal: this._toggleMetaModal,
        showModal: this.state.showQuoteMetaModal,
        loading: this.props.loading,
        edit: this.props.editQuote,
        isMasterSite: this.props.isMasterSite,
        isEdit: true,
        data: quote,
        whitelabel: this.props.whitelabel,
        advisorMeta: this.props.advisorMeta
      })), this.props.selectedSection === 'classes-divisions' && /*#__PURE__*/_react["default"].createElement(_ClassesDivisions["default"], {
        currentAccountMeta: this.props.currentAccountMeta,
        setState: this.props.setState,
        editClass: this.props.editClass,
        addClass: this.props.addClass,
        removeClass: this.props.removeClass,
        addDivision: this.props.addDivision,
        editDivision: this.props.editDivision,
        removeDivision: this.props.removeDivision,
        validateBankingDetails: this.props.validateBankingDetails,
        bankingDetailsVerifying: this.props.bankingDetailsVerifying,
        classData: quote.classes,
        divisions: quote.divisions,
        isQuote: true,
        isMasterSite: this.props.isMasterSite,
        step: quote.meta.state,
        loading: this.props.loading,
        whitelabel: whitelabel,
        language: this.props.language || "en"
      }), this.props.selectedSection === 'account-history' && /*#__PURE__*/_react["default"].createElement(_AccountHistory["default"], {
        uploadAccountHistory: this.props.uploadAccountHistory,
        isMasterSite: this.props.isMasterSite,
        accountID: this.props.currentAccountMeta.accountID,
        isQuote: true,
        loading: this.props.loading,
        whitelabel: whitelabel
      }), this.props.selectedSection === 'plan-design' && /*#__PURE__*/_react["default"].createElement(_Container["default"], {
        setSelectedSection: this.props.setSelectedSection,
        quote: quote,
        isMasterSite: this.props.isMasterSite,
        isQuote: true,
        step: quote.meta.state,
        currentAccountMeta: this.props.currentAccountMeta,
        classData: quote.classes,
        designs: quote.planDesigns,
        modularBlueprints: quote.modularBlueprints,
        submitPlanDesigns: this.props.submitPlanDesigns,
        submitModuleBlueprint: this.props.submitModuleBlueprint,
        savePlanType: this.props.savePlanType,
        createPlanDesign: this.props.createPlanDesign,
        createPlanDesignFromUpload: this.props.createPlanDesignFromUpload,
        savePlanDesign: this.props.savePlanDesign,
        clonePlanDesign: this.props.clonePlanDesign,
        savePlanDesignBenefitInitData: this.props.savePlanDesignBenefitInitData,
        savePlanDesignField: this.props.savePlanDesignField,
        getPlanDesignRevisions: this.props.getPlanDesignRevisions,
        getSinglePlanDesignRevision: this.props.getSinglePlanDesignRevision,
        revertToRevision: this.props.revertToRevision,
        saveModularBlueprint: this.props.saveModularBlueprint,
        saveModularBenefitInitData: this.props.saveModularBenefitInitData,
        saveModularField: this.props.saveModularField,
        loading: this.props.loading,
        whitelabel: whitelabel,
        language: this.props.advisorMeta.language || 'en'
      }), this.props.selectedSection === 'commissions' && /*#__PURE__*/_react["default"].createElement(_Commissions["default"], {
        isMasterSite: this.props.isMasterSite,
        currentAccountMeta: this.props.currentAccountMeta,
        isQuote: true,
        setSelectedSection: this.props.setSelectedSection,
        submitCommissions: this.props.submitCommissions,
        saveCommissions: this.props.saveCommissions,
        getCommissions: this.props.getCommissions,
        loading: this.props.loading,
        whitelabel: whitelabel
      }), this.props.selectedSection === 'master-application' && /*#__PURE__*/_react["default"].createElement(_MasterApplication["default"], {
        setSelectedSection: this.props.setSelectedSection,
        advisorMeta: this.props.advisorMeta,
        isMasterSite: this.props.isMasterSite,
        isQuote: true,
        quote: quote,
        currentAccountMeta: this.props.currentAccountMeta,
        isReadOnly: quote.meta.status !== 'In Progress' || quote.meta.state >= 7,
        getMasterApplicationData: this.props.getMasterApplicationData,
        updateMasterApp: this.props.updateMasterApp,
        completeMasterApp: this.props.completeMasterApp,
        loading: this.props.loading,
        displayError: this.props.displayError,
        whitelabel: whitelabel
        // isPrivateLabelAdvisor={ isPrivateLabelAdvisor }
      }), this.props.selectedSection === 'request-approval' && /*#__PURE__*/_react["default"].createElement(_MasterApplication["default"], {
        setSelectedSection: this.props.setSelectedSection,
        advisorMeta: this.props.advisorMeta,
        isMasterSite: this.props.isMasterSite,
        isQuote: true,
        quote: quote,
        currentAccountMeta: this.props.currentAccountMeta,
        getMasterApplicationData: this.props.getMasterApplicationData,
        updateMasterApp: this.props.updateMasterApp,
        completeMasterApp: this.props.completeMasterApp,
        sendRequestApprovalLink: this.props.sendMasterAppLink,
        loading: this.props.loading,
        displayError: this.props.displayError,
        whitelabel: whitelabel
      }), this.props.selectedSection === 'pricing' && this.props.isMasterSite && /*#__PURE__*/_react["default"].createElement(_Pricing["default"], {
        classData: quote.classes,
        designs: quote.planDesigns,
        commissions: quote.commissions,
        setSelectedSection: this.props.setSelectedSection,
        advisorMeta: this.props.advisorMeta,
        isMasterSite: this.props.isMasterSite,
        quote: quote,
        isQuote: true,
        currentAccountMeta: this.props.currentAccountMeta,
        submitPricing: this.props.submitPricing,
        savePricingInput: this.props.savePricingInput,
        savePricing: this.props.savePricing,
        saveTelusDrugPlanID: this.props.saveTelusDrugPlanID,
        getPricingRevisions: this.props.getPricingRevisions,
        getSinglePricingRevision: this.props.getSinglePricingRevision,
        saveCoverages: this.props.saveCoverages,
        loading: this.props.loading,
        whitelabel: whitelabel
      }), this.props.selectedSection === 'assign-plans' && /*#__PURE__*/_react["default"].createElement(_AssignPlans["default"], {
        classData: quote.classes,
        designs: quote.planDesigns,
        setSelectedSection: this.props.setSelectedSection,
        advisorMeta: this.props.advisorMeta,
        isMasterSite: this.props.isMasterSite,
        quote: quote,
        isQuote: true,
        currentAccountMeta: this.props.currentAccountMeta,
        getPlanDesignPremiumSummaries: this.props.getPlanDesignPremiumSummaries,
        assignPlans: this.props.assignPlans,
        rejectPricing: this.props.rejectPricing,
        loading: this.props.loading,
        whitelabel: whitelabel
      }), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showSendForReviewDialog,
        close: this._toggleSendForReviewDialog,
        title: _i18n["default"].t(_tokens["default"].titles.areYouSure),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: function onSave() {
          _this2._toggleSendForReviewDialog();
          _this2.props.sendReviewRequest(null);
        },
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons.requestReview),
        customContainerStyle: {
          width: 500
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.quotes.requestReview)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showConvertQuote,
        close: this._toggleConvertQuote,
        title: _i18n["default"].t(_tokens["default"].titles.areYouSure),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._convertQuoteToSold,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons["continue"])
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, "By clicking the button below, you will be finishing the Quoting process and converting the Quote to an account within the Simply Benefits system. From this point on you will be required to enter the Census data and set the account live."), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = Quote;